import { render } from "./PerformanceMarketingBusinessDataForm.vue?vue&type=template&id=63814486"
import script from "./PerformanceMarketingBusinessDataForm.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingBusinessDataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__